export default {
  GET_LEADS_OPTIN_STATISTICS_REQUEST: '@@leads/GET_LEADS_OPTIN_STATISTICS_REQUEST',
  GET_LEADS_OPTIN_STATISTICS_SUCCESS: '@@leads/GET_LEADS_OPTIN_STATISTICS_SUCCESS',
  GET_LEADS_OPTIN_STATISTICS_ERROR: '@@leads/GET_LEADS_OPTIN_STATISTICS_ERROR',
};
